/*
  F&NT · Descuento por volumen siempre visible (v11, 24 sep 2026)
  Antes: los botones 1 / 2 / 3 o más piezas vivían dentro de "Compra única" y se ocultaban
  porque "Suscríbete y ahorra" viene marcada. Ahora se ven siempre que la presentación
  tenga volumen; al elegir 2 o 3+ se cambia sola a Compra única (el volumen no aplica en suscripción).
  Complementa el script de blocks/fnt-pdp.liquid sin tocarlo. Deuda: integrarlo a fnt-pdp en el próximo cambio grande.
  Lo carga el bloque de título de las plantillas de producto.
*/
(function () {
  if (window.__fntVolReady) return;
  window.__fntVolReady = true;

  var SIZE_NAMES = ['gramaje', 'presentación', 'presentacion', 'tamaño', 'tamano'];
  var PCT = { '2': '−5%', '3': '−10%' };

  function data() {
    var el = document.querySelector('[data-fnt-pdp-data]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function form() {
    return document.querySelector('.product-details form[data-type="add-to-cart-form"]') ||
      document.querySelector('form[data-type="add-to-cart-form"]');
  }

  function sizeIndex(d) {
    var names = d.optionNames || [];
    for (var i = 0; i < names.length; i++) {
      if (SIZE_NAMES.indexOf(String(names[i]).trim().toLowerCase()) > -1) return i;
    }
    return 0;
  }

  function eligible(d) {
    if (!d || !d.volume || !d.volume.sizes || !d.volume.sizes.length) return false;
    var f = form();
    var input = f && f.querySelector('input[name="id"]');
    var id = input ? Number(input.value) : 0;
    var v = d.variants.filter(function (x) { return x.id === id; })[0] || d.variants[0];
    var size = sizeIndex(d) === 1 ? v.o2 : v.o1;
    return d.volume.sizes.indexOf(size) > -1;
  }

  function labels(box) {
    box.querySelectorAll('[data-fnt-tier]').forEach(function (b) {
      var pct = PCT[b.dataset.fntTier];
      if (!pct || b.querySelector('.fnt-vol-pct')) return;
      var s = document.createElement('small');
      s.className = 'fnt-vol-pct';
      s.textContent = ' ' + pct;
      b.appendChild(s);
    });
  }

  function sync() {
    var box = document.querySelector('[data-fnt-vol]');
    if (!box) return;
    var show = eligible(data());
    if (box.hidden === show) box.hidden = !show;
    labels(box);
  }

  // Elegir 2 o 3+ con la suscripción marcada → pasa a Compra única antes de que fnt-pdp procese el clic
  document.addEventListener('click', function (e) {
    var tier = e.target.closest && e.target.closest('[data-fnt-tier]');
    if (!tier || Number(tier.dataset.fntTier) < 2) return;
    var plans = document.querySelector('[data-fnt-plans]');
    var once = plans && plans.querySelector('input[value="once"]');
    if (once && !once.checked) {
      once.checked = true;
      once.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }, true);

  function start() {
    var box = document.querySelector('[data-fnt-vol]');
    if (!box) return;
    var style = document.createElement('style');
    style.textContent =
      '.fnt-pdp__vol .fnt-vol-pct{font-size:12px;font-weight:700;color:#CDB48E}' +
      '.fnt-pdp__plan--once:not(:has(input:checked)) .fnt-pdp__tier.is-on{border:1px solid #3a3a3a;background:#151515;padding:8px 6px}';
    document.head.appendChild(style);
    new MutationObserver(sync).observe(box, { attributes: true, attributeFilter: ['hidden'] });
    document.addEventListener('change', function () { setTimeout(sync, 80); });
    setInterval(sync, 500);
    sync();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
